// Wishlist: lưu vào DB qua API (cho user đã đăng nhập), kèm cache localStorage để render nhanh.
// Với khách (guest), dùng localStorage thuần.
import { favoriteService } from '../services/api';

const KEY_PREFIX = 'wishlist_';
const EVENT_NAME = 'wishlist:change';

const keyFor = (userId) => KEY_PREFIX + (userId || 'guest');
const isGuest = (userId) => !userId || userId === 'guest';

export const getWishlist = (userId) => {
	try {
		const raw = localStorage.getItem(keyFor(userId));
		return raw ? JSON.parse(raw) : [];
	} catch (_) {
		return [];
	}
};

const save = (userId, list) => {
	localStorage.setItem(keyFor(userId), JSON.stringify(list));
	window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { userId } }));
};

const normalizeCover = (img) => {
	if (!img) return null;
	if (typeof img === 'object' && img.path) return { path: img.path };
	if (typeof img === 'string' && (img.startsWith('/') || img.includes('.'))) return { path: img };
	return null;
};

const toLite = (hotel) => ({
	_id: hotel._id,
	name: hotel.name,
	coverImage: normalizeCover(hotel.coverImage),
	city: hotel.city || '',
	district: hotel.district || '',
	ward: hotel.ward || '',
	minRoomPrice: hotel.minRoomPrice ?? null,
	average_rating: hotel.average_rating ?? null,
	total_reviews: hotel.total_reviews ?? 0,
	addedAt: Date.now(),
});

export const isWishlisted = (userId, hotelId) => {
	if (!hotelId) return false;
	return getWishlist(userId).some((h) => String(h._id) === String(hotelId));
};

export const addToWishlist = (userId, hotel) => {
	if (!hotel?._id) return;
	const list = getWishlist(userId);
	if (list.some((h) => String(h._id) === String(hotel._id))) return;
	save(userId, [toLite(hotel), ...list]);
	if (!isGuest(userId)) {
		favoriteService.add(hotel._id).catch((err) => {
			console.error('addFavorite failed:', err);
		});
	}
};

export const removeFromWishlist = (userId, hotelId) => {
	const list = getWishlist(userId).filter((h) => String(h._id) !== String(hotelId));
	save(userId, list);
	if (!isGuest(userId)) {
		favoriteService.remove(hotelId).catch((err) => {
			console.error('removeFavorite failed:', err);
		});
	}
};

export const toggleWishlist = (userId, hotel) => {
	if (isWishlisted(userId, hotel?._id)) {
		removeFromWishlist(userId, hotel._id);
		return false;
	}
	addToWishlist(userId, hotel);
	return true;
};

// Đồng bộ danh sách yêu thích từ server vào localStorage (gọi khi user đăng nhập / load app)
export const hydrateWishlistFromServer = async (userId) => {
	if (isGuest(userId)) return;
	try {
		const res = await favoriteService.getAll();
		const list = Array.isArray(res?.data) ? res.data : [];
		const mapped = list
			.filter((h) => h && h._id)
			.map((h) => ({ ...toLite(h), addedAt: Date.now() }));
		save(userId, mapped);
	} catch (err) {
		// Không phá UX khi server lỗi — vẫn giữ cache cũ
		console.error('hydrateWishlistFromServer failed:', err);
	}
};

export const onWishlistChange = (handler) => {
	const cb = (e) => handler(e.detail);
	window.addEventListener(EVENT_NAME, cb);
	window.addEventListener('storage', cb);
	return () => {
		window.removeEventListener(EVENT_NAME, cb);
		window.removeEventListener('storage', cb);
	};
};
